import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import Accordion from 'Feature/ContentComponents/code/assets/componets/accordion';

ComponentsFactory.getInstance().define('accordion', Accordion);
